import React, { useEffect, useMemo, useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import { useTranslation } from "react-i18next";
import { getCourseById, getCourses } from "../../api/courses";
import CourseDetailHero from "../../components/pages/CourseDetail/CourseDetailHero/CourseDetailHero";
import CourseDetailProgram from "../../components/pages/CourseDetail/CourseDetailProgram/CourseDetailProgram";
import "../Academy/Academy.css";
import { COURSE_IMAGES } from "../../components/pages/Academy/Courses/courseImages";
import Courses from "../../components/pages/Academy/Courses/Courses";
import GetInTouch from "../../components/pages/Academy/GetInTouch/GetInTouch";
import CourseHighlights from "../../components/pages/CourseDetail/CourseHighlights/CourseHighlights";

const CourseDetail = () => {
  const { i18n } = useTranslation();
  const { courseId } = useParams();
  const location = useLocation();
  const [course, setCourse] = useState(null);
  const [resolved, setResolved] = useState(false);
  const [heroImage, setHeroImage] = useState(location.state?.heroImage || "");

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      setResolved(false);
      const language = String(i18n.language || "en").toLowerCase();
      try {
        const [detail, list] = await Promise.all([
          getCourseById({ id: courseId, language }),
          getCourses({ language }),
        ]);
        if (!isMounted) return;
        setCourse(detail || null);
        if (!heroImage) {
          const idx = (Array.isArray(list) ? list : []).findIndex(
            (item) => String(item?.id) === String(courseId)
          );
          if (idx >= 0) {
            setHeroImage(COURSE_IMAGES[idx % COURSE_IMAGES.length]);
          } else {
            setHeroImage(COURSE_IMAGES[0]);
          }
        }
      } catch {
        if (isMounted) setCourse(null);
      } finally {
        if (isMounted) setResolved(true);
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [courseId, i18n.language]);

  const resolvedHero = useMemo(() => heroImage || COURSE_IMAGES[0], [heroImage]);

  if (!resolved) return null;
  if (!course) return <Navigate to="/academy" replace />;

  return (
    <div className="academy-page">
      <Navbar theme="light" />
      <CourseDetailHero course={course} heroImage={resolvedHero} />
      <div className="academy-page-content-guide">
        <div id="course-detail-program">
          <CourseDetailProgram course={course} />
        </div>
        <Courses />
        <GetInTouch />
        <CourseHighlights />
      </div>
      <Footer />
    </div>
  );
};

export default CourseDetail;
